import { defineMessages } from '@atlassian/jira-intl';

export const messages: {
	starred: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	starred: {
		id: 'directories.common.components.star-title-cell.starred',
		defaultMessage: 'Starred',
		description: 'Assistive label for the Starred sorting button table header',
	},
});
